import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DailyRentWarningModal = ({ open, onCancel, onProceed }) => {
  return (
    <Dialog aria-labelledby="daily-rent-warning-title" className="add-lease-dialog" open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }} className="dialog-header" id="daily-rent-warning-title">
        <WarningAmberIcon sx={{ color: "#a78701" }} /> Enable Daily Rent on an active lease?
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          This Rental Rate is part of an <b>active, in-progress lease</b>. Enabling Daily Rent will change how invoices are calculated <b>from this point forward</b>. Previously generated, sent or paid invoices are <b>not</b> recalculated.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: 1, justifyContent: "flex-end", marginRight: "15px" }}>
        <Button className="cancel-btn" size="small" variant="outlined" onClick={onCancel}>Cancel</Button>
        <Button size="small" variant="contained" onClick={onProceed}>Proceed anyway</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DailyRentWarningModal;
